import React, { useEffect, useState } from "react";

import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import Loading from "../../atoms/loading/loading";
import HeadboardPodcastDetail from "../headboard-podcast-detail/headboardPodcastDetail";
import PodcastDescription from "../podcast-description/podcastDescription";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";

import "./podcastDetail.scss";

const months = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

const PodcastDetail = (props: { 0: ReferenciaCabecera } | {}) => {
  const [data, setData] = useState<any>(null);
  const { window } = useBrowserMode();

  useEffect(() => {
    if (
      props[0] &&
      props[0].botonCompartir &&
      props[0].tituloBoton &&
      props[0].tipoCabecera === "DetallePodcast"
    ) {
      fetch(
        `${process.env.CONTENTLOAN_API_URL}/contentloan/api/v1/detail/collection-podcast?mmsId=${props[0].botonCompartir}&pid=${props[0].tituloBoton}`
      ).then(async (res) => {
        const jsonRes = await res.json();
        if (jsonRes.status === 200) setData(jsonRes.data);
      });
    } else {
      let url = new URL(window.location.href);
      let jsonUrlParams = getJsonFromUrl(url.search);
      fetch(
        `${process.env.CONTENTLOAN_API_URL}/contentloan/api/v1/detail/podcast?mmsId=${jsonUrlParams.podcast}`
      ).then(async (res) => {
        const jsonRes = await res.json();
        if (jsonRes.status === 200) setData(jsonRes.data);
      });
    }
  }, []);

  const getJsonFromUrl = (url: string) => {
    let query = url.substr(1);
    let result: { podcast: string } = {
      podcast: "",
    };
    query.split("&").forEach(function (part) {
      let item = part.split("=");
      result[item[0]] =
        decodeURIComponent(item[1]) === "null"
          ? null
          : decodeURIComponent(item[1]);
    });
    return result;
  };

  const formatDate = (date: string) => {
    const dateElements = date.split("/");
    return `${dateElements[0]} de ${
      months[parseInt(dateElements[1]) - 1]
    } del ${dateElements[2]}`;
  };

  return (
    <div
      className={`o-podcast-detail ${
        props[0] && props[0].tipoCabecera === "DetallePodcast"
          ? "o-podcast-detail--headboard"
          : ""
      }`}
    >
      {data ? (
        <>
          <HeadboardPodcastDetail
            contentful_id={props[0] ? props[0].contentful_id : ""}
            breadcrumb={
              props[0]
                ? props[0].migaDePan
                : `Inicio / Todos los podcasts / ${data.title}`
            }
            image={data.cover}
            date={data.creationDate ? formatDate(data.creationDate) : ""}
            title={data.title}
            author={data.author}
            episodes={data.numberOfEpisodes || ""}
            duration={data.duration || ""}
            links={data.links}
            mmsId={data.mmsid}
          />
          {data.linksFunctional[0] && !props[0] && (
            <div className="o-podcast-detail__iframe-audio">
              <iframe
                src={data.linksFunctional[0].link}
                width="400px"
                frameBorder="0"
                scrolling="no"
              />
            </div>
          )}
          <PodcastDescription
            description={data.description}
            tags={data.subjects}
            author={data.author}
            series={data.serie || []}
            episodes={data.numberOfEpisodes || ""}
            duration={data.duration || ""}
            format={data.format}
            language={data.language}
            tabs={props[0] ? props[0].referenciaTags : []}
            title={data.title}
          />
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default PodcastDetail;
